export default {
	setAccount(state, account) {
		state.account = account;
	},

	activateTrial(state) {
		state.account.trial = 'active';
	},

	addTimelineToContextualization(state, timeline) {
		if (! state.contextualization.timelines.includes(timeline) && state.contextualization.timelines.length < 4) {
			state.contextualization.timelines.push(timeline);
		}
	},

	removeTimelineFromContextualization(state, timeline) {
		var index = state.contextualization.timelines.findIndex(function(element) {
			return element.id === timeline.id;
		});
		state.contextualization.timelines.splice(index, 1);
	},

	toogleContextualizationPanelStatus(state) {
		state.contextualization.panel.extended = ! state.contextualization.panel.extended;

		if (state.contextualization.timelines.length == 0) {
			state.contextualization.panel.visible = false;
		}
	},

	extendContextualizationPanel(state) {
		state.contextualization.panel.extended = true;
	},

	showContextualizationPanel(state) {
		state.contextualization.panel.visible = true;
	},

	hideContextualizationPanel(state) {
		state.contextualization.panel.visible = false;
	},

	cleanContextualizationTimelines(state) {
		state.contextualization.timelines = [];
	}
}